import React from 'react';
import styled from 'styled-components';
import { BackIcon } from '@lt/components/icons-react/auth';

interface Props {
  onClick?: () => void;
  className?: string;
}

export const BackButton: React.FC<Props> = ({ onClick, className }) => (
  <Container className={className} onClick={onClick}>
    <BackIcon width={24} height={24} />
  </Container>
);

const Container = styled.button.attrs({ type: 'button' })`
  position: absolute;
  top: 0;
  left: 0;
  border: none;
  outline: none;
  cursor: pointer;
  background: transparent;
`;
